var req = require("!!/app/node_modules/pug-loader/index.js??ref--12-1!/app/src/linagora.esn.calendar/app/calendar-shared-configuration/item/calendar-shared-configuration-item.pug");
module.exports = (req['default'] || req).apply(req, [])